import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import DatePicker from "react-datepicker";
import { getFeatureSetOption, getFeaturesList, userRoles } from "../../../../constant";
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from "assets/icons/search-icon.png";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useHookstate } from "@hookstate/core";
import { PopUpContainer } from "assets/css/globle";
import UnCheckedIcon from "assets/svgIcons/RadioUncheckIcon";
import CheckedIcon from "assets/svgIcons/RadioCheckedIcon";
import RedoIcon from "assets/svgIcons/Redo";
import UndoIcon from "assets/svgIcons/Undo";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "assets/svgIcons/ExpandMoreIcon";
import CloseIcon from "assets/svgIcons/ModalCloseOutIcon";
import CopyIcon from "assets/svgIcons/CopyIcon";
import CrossIcon from "assets/svgIcons/CloseRoundIcon";
import {
  AccordionContainer,
  TableWrapper,
} from "pages/Ads/Campaigns/EditCampaign/TableStyled";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import Tooltip from "@mui/material/Tooltip";
import {
  Container,
  Header,
  Wrapper,
  Section,
  CircleBtn,
  NormalBtn,
} from "pages/Ads/Campaigns/CampaignsStyled";
import { useTranslation } from "react-i18next";
import {
  PreviewBox,
  AdPreview,
  ImagePreviewBox,
  GallerySection,
  GalleryHeading,
  CenterSection,
  SearchWrapper,
  Status,
  DescriptionSection,
  GalleryDetails,
  GalleryWrapper,
  MainDataWrapper,
  ArchivedCampaignContainerModal,
} from "pages/Ads/Campaigns/EditCampaign/EditCampaignStyled";
import { useEffect } from "react";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ADS_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { gallerySearch } from "./gallerySearch";
import { getAdImageApiCall } from "redux/reduxToolkitServices/_commonApiCalls/api";
import { headersConfigData } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { undoFunc } from "pages/Ads/functions/undoFunc";
import { redoFunc } from "pages/Ads/functions/redoFunc";

const EditCampaign = () => {
  const { t } = useTranslation();

  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { siteId, hasSiteChangedAds } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    publishCampButtonState,
    redirectState,
    alertMsg,
    shouldShowPublishNow,
  } = useHookstate(ADS_GLOBAL_STATE);

  const navigate = useNavigate();
  const { getCampaignsStateData, getImageGalleryData, siteSettingsData, getWelcomeAdsData } = useSelector((state) => state.commonReducers);
  const { getAdImageData, getAdInsertImageData, getUserRole } = useSelector((state) => state.commonReducers) || [];

  let singleCampaignData = {};

  const dispatch = useDispatch();

  const { state } = useLocation();
  const dragItem = useRef();

  const [prevTableData, setPrevTableData] = useState([]);
  const [sharedImages, setSharedImages] = useState(true);
  const [localImages, setLocalImages] = useState(true);
  const [dropDownValue, setDropDownValue] = useState("date");
  const [radioInputValue, setRadioInputValue] = useState("full");
  const [fullImagesArray, setFullImagesArray] = useState([]);
  const [searchFullImagesArray, setSearchFullImagesArray] = useState([]);
  const [insertClonedArray, setInsertClonedArray] = useState([]);
  const [searchInsertClonedArray, setSearchInsertClonedArray] = useState([]);
  const [lastDay] = useState();
  const [showImage, setShowImage] = useState("");
  const [descInputValue, setDescInputValue] = useState("");
  const [descError, setDescError] = useState(false);
  const [activeButton, setActiveButton] = useState([]);
  const [openArchivedCampaignModal, setOpenArchivedCampaignModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [allCampData, setAllCampData] = useState({});
  const [undoTableData, setUndoTableData] = useState([]);
  const [redoTableData, setRedoTableData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [archiveId, setArchiveId] = useState("");
  const [archiveCampId, setArchiveCampId] = useState("");
  const [openLoadCampaignArchiveConfirmation, setOpenLoadCampaignArchiveConfirmation] = useState(false);
  const [detectArchiveChange, setDetectArchiveChange] = useState(false);
  const [coursesPayload, setCoursesPayload] = useState([]);
  const [welcomeImagesExpanded, setWelcomeImagesExpanded] = useState(false);
  const [welcomeImageSlots, setWelcomeImageSlots] = useState(1);
  const [tempSlotCount, setTempSlotCount] = useState(1);
  singleCampaignData = state?.filteredData[0];
  const [welcomeImages, setWelcomeImages] = useState([
    {
      WelcomeAdId: singleCampaignData?.welcomeAd?.imageId ?? 0,
    },
    ...Array(4)
      .fill()
      .map(() => ({
        WelcomeAdId: 0,
      })),
  ]);
  const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);

  const timeZoneOffset = siteSettingsData && siteSettingsData?.TimeZoneOffset;

  singleCampaignData = state?.filteredData[0];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 444,
    bgcolor: "#fff",
    borderRadius: "5px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  }

  const campaignContainerModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 605,
    padding: "0",
    borderRadius: "5px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
  }

  useEffect(() => {
    if (hasSiteChangedAds.get()) {
      mapSideNavTabState.set("Campaigns");
      hasSiteChangedAds.set(false);
    }
  }, [siteId.get()]);

  useEffect(() => {
    setStartDate(
      singleCampaignData?.startDateUtc != null
        ? new Date(
          moment
            .utc(singleCampaignData?.startDateUtc)
            .utcOffset(-siteSettingsData?.TimeZoneOffset)
            .format("DD-MMM-YYYY")
        )
        : null
    );
    setEndDate(
      singleCampaignData?.endDateUtc != null
        ? new Date(
          moment
            .utc(singleCampaignData?.endDateUtc)
            .utcOffset(-siteSettingsData?.TimeZoneOffset)
            .format("DD-MMM-YYYY")
        )
        : null
    );
    setDescInputValue(singleCampaignData?.Description);
    setPrevTableData(singleCampaignData?.courses);
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
    dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));

    if (singleCampaignData != undefined) {
      let length = singleCampaignData?.courses?.length;
      let buttonStatus = Array(length).fill(false);
      setActiveButton(buttonStatus);
      setTableData(singleCampaignData?.courses);
      setCoursesPayload(singleCampaignData?.courses);
    }
  }, [siteId.get()]);

  useEffect(() => {
    setAllCampData(singleCampaignData);
    if (singleCampaignData?.welcomeImages && singleCampaignData?.welcomeImages.length > 0) {
      const welcomeImagesFromData = singleCampaignData.welcomeImages.map((imageData, index) => {
        const finalId = imageData.WelcomeAdId;
        return {
          WelcomeAdId: finalId
        };
      });

      // Ensure we have at least 5 slots, fill remaining with empty slots
      const totalSlots = Math.max(welcomeImagesFromData.length, 5);
      const filledImages = Array(totalSlots).fill().map((_, index) =>
        welcomeImagesFromData[index] || { WelcomeAdId: 0 }
      );
      setWelcomeImages(filledImages);
      setWelcomeImageSlots(totalSlots);
      setWelcomeImagesExpanded(true); // Auto-expand to show the images
    }
  }, [singleCampaignData]);

  useEffect(() => {
    let images = [];
    getCampaignsStateData &&
      getCampaignsStateData?.images?.map(async (item) => {
        const { id } = item;
        let response = await getAdImageApiCall(id, headersConfigData);
        let imageBlob = await response.blob();
        let reader = new FileReader();
        reader.readAsDataURL(imageBlob);

        reader.onloadend = () => {
          let base64data = reader.result;
          images = [...images, { base64data, ...item }];
          setFullImagesArray(images);
          setSearchFullImagesArray(images);
        };
      });
  }, [getCampaignsStateData]);

  useEffect(() => {
    let images = [];
    getCampaignsStateData &&
      getCampaignsStateData?.images?.map(async (item) => {
        if (item?.fullPage === false) {
          const { id } = item;
          let response = await getAdImageApiCall(id, headersConfigData);
          let imageBlob = await response.blob();
          let reader = new FileReader();
          reader.readAsDataURL(imageBlob);

          reader.onloadend = () => {
            let base64data = reader.result;
            images = [...images, { base64data, ...item }];
            setInsertClonedArray(images);
            setSearchInsertClonedArray(images);
          };
        }
      });
  }, [getCampaignsStateData]);

  useEffect(() => {
    if (getAdImageData)
      setFullImagesArray(JSON.parse(JSON.stringify(getAdImageData)));
  }, [getAdImageData]);

  useEffect(() => {
    if (getAdInsertImageData)
      setInsertClonedArray(JSON.parse(JSON.stringify(getAdInsertImageData)));
  }, [getAdInsertImageData]);

  useEffect(() => {
    let chkDate = moment(lastDay).isAfter(new Date(), "day");
    publishCampButtonState.set(chkDate);
  }, [lastDay]);

  useEffect(() => {
    if (startDate > endDate) setEndDate(startDate);
  }, [startDate]);

  useEffect(() => {
    if (startDate > endDate) setStartDate(endDate);
  }, [endDate]);


  //useEffect to track the editable fields
  useEffect(() => {
    const descChanged = descInputValue !== singleCampaignData?.Description;

    const startChanged = startDate?.toDateString() !==
      (singleCampaignData?.startDateUtc ? new Date(singleCampaignData.startDateUtc).toDateString() : undefined);

    const endChanged = endDate?.toDateString() !==
      (singleCampaignData?.endDateUtc ? new Date(singleCampaignData.endDateUtc).toDateString() : undefined);

    const originalWelcome = (singleCampaignData?.welcomeImages || []).map(img => img.WelcomeAdId);
    const currentWelcome = welcomeImages.filter(img => img.WelcomeAdId !== 0).map(img => img.WelcomeAdId);
    const welcomeChanged = JSON.stringify(originalWelcome) !== JSON.stringify(currentWelcome);

    const cleanCurrent = JSON.parse(
      JSON.stringify(tableData).replace(/,"modified":false|,"modified":true/g, "")
    );
    const cleanOriginal = JSON.parse(
      JSON.stringify(prevTableData).replace(/,"modified":false|,"modified":true/g, "")
    );
    const tableChanged = JSON.stringify(cleanCurrent) !== JSON.stringify(cleanOriginal);

    for (let i = 0; i < tableData.length; i++) {
      if (JSON.stringify(cleanOriginal[i]) === JSON.stringify(cleanCurrent[i]))
        activeButton[i] = false;
      else activeButton[i] = true;
      setActiveButton([...activeButton]);
    }

    redirectState.set(descChanged || startChanged || endChanged || welcomeChanged || tableChanged);
  }, [descInputValue, startDate, endDate, welcomeImages, tableData]);

  //########Modal for Loading Archive##############//
  const handleArchivedCampaignModalClose = () => {
    setOpenArchivedCampaignModal(false);
    setDetectArchiveChange(false);
    setArchiveId("");
  }

  //########Modal for Loading Archive##############//

  const handleChange = (panel) => () => {
    setExpanded(expanded === panel ? false : panel);
  }

  //#################Load Archive section################//

  const modifiedArchive = [];

  getCampaignsStateData?.archives?.forEach((c) => {
    const obj = {
      ...c,
    };
    modifiedArchive.push(obj);
  });

  function verboseToDate(vd) {
    if (vd?.year === undefined) {
      return;
    } else {
      return new Date(
        Date.UTC(vd.year, vd.month - 1, vd.day, vd.hour, vd.minute, vd.second)
      );
    }
  }

  function campPayload(singleCampaignData) {
    let newPayload = {};

    newPayload.Id = singleCampaignData?.Id;
    newPayload.Description = descInputValue;
    newPayload.SiteId = singleCampaignData?.SiteId;
    newPayload.baseVersion = singleCampaignData?.baseVersion;
    newPayload.lastModifiedUtc = singleCampaignData?.lastModifiedUtc;
    newPayload.lastModifiedBy = singleCampaignData?.lastModifiedBy;

    newPayload.fbAd = allCampData?.fbAd;
    newPayload.welcomeImages = welcomeImages.filter(img => img.WelcomeAdId && img.WelcomeAdId !== 0);
    newPayload.videoTags = singleCampaignData?.videoTags;
    newPayload.startDateUtc = midnightLocal(startDate).toISOString();
    newPayload.endDateUtc = midnightLocal(endDate).toISOString();
    newPayload.tournamentId = singleCampaignData?.tournamentId;
    newPayload.tournamentName = singleCampaignData?.tournamentName;
    newPayload.courses = coursesPayload;

    return newPayload;
  }

  function midnightLocal(date) {
      return moment(date)
          .utcOffset(-siteSettingsData?.TimeZoneOffset, true)
          .startOf('day');
  }

  function sortAndFilter(type, arr) {
    if (type === "desc") {
      return arr?.sort((a, b) => {
        return a.description > b.description
          ? 1
          : a.description < b.description
            ? -1
            : 0;
      });
    } else if (type === "file") {
      return arr?.sort((a, b) => {
        let fA = a.filename.toUpperCase();
        let fB = b.filename.toUpperCase();
        return fA > fB ? 1 : fA < fB ? -1 : 0;
      });
    } else if (type === "date") {
      return arr?.sort((a, b) => {
        return verboseToDate(b?.uploadedUtc) - verboseToDate(a?.uploadedUtc);
      });
    } else {
      return arr?.sort((a, b) => {
        return a?.size - b?.size;
      });
    }
  }

  const renderImage = (evt, arr) => {
    if (Number(evt.target.id) === 0) {
      return;
    }
    imageName(evt.target.id);
    const returnedElem =
      arr?.length !== 0 &&
      arr?.filter((item) => {
        return item?.id === Number(evt.target.id);
      });

    setShowImage(returnedElem[0]);
  }

  const navigateToCampaigns = () => {
    mapSideNavTabState.set("Campaigns");
    navigate("/ads");
  }

  function modifiedDate() {
    let result = moment.utc(singleCampaignData?.lastModifiedUtc); // put in local mode so settings apply to local time
    result.utcOffset(-timeZoneOffset); // set timezone to match course
    return result.format("DD-MMM-YYYY hh:mm a");
  }

  function worksheet() {
    let bv = singleCampaignData?.baseVersion;
    let arr = getCampaignsStateData?.archives;
    let results = arr?.filter((e) => e?.version === bv);

    let basedon = results[0];
    return {
      version: basedon
        ? "Version " + basedon?.version + " - " + basedon?.comment
        : "Version " + singleCampaignData?.baseVersion,

      date: singleCampaignData?.lastModifiedUtc?.toString(),
      by: singleCampaignData?.lastModifiedBy,
    };
  }
  //##########Modal for Loading Archive################//

  function descOrName(image) {
    if (image.description) return image.description;
    return image.filename;
  }

  function getImageById(imageId) {
    if (getImageGalleryData) {
      let result = getImageGalleryData?.filter(
        (e) => e.id === imageId
      );
      if (result.length > 0) {
        return result[0];
      }
    }
    return null;
  }

  const imageName = (imageId) => {

    if (imageId) {
      // First try to find in regular campaign images
      let image = getImageById(imageId);
      if (image) {
        return descOrName(image);
      }

      // If not found, try to find in welcome ads images
      if (getWelcomeAdsData?.Images) {
        const welcomeImage = getWelcomeAdsData.Images.find(img =>
          img.ImageId === imageId
        );
        if (welcomeImage) {
          const name = welcomeImage.filename || welcomeImage.description || `Welcome Image ${imageId}`;
          return name;
        }
      }
    }
    return "";
  }

  const tablePayload = (tableDataInfo, courseDetail, courseIndex) => {
    let newTablePayload = {};
    newTablePayload.id = courseDetail?.id;
    newTablePayload.name = courseDetail?.name;
    newTablePayload.number = courseDetail?.number;
    newTablePayload.rotationAd = tableDataInfo[courseIndex]?.rotationAd;
    newTablePayload.holes = tableDataInfo[courseIndex]?.holes;

    return newTablePayload;
  }

  function handleSaveEditDesc() {
    let payload = campPayload(singleCampaignData);

    setUndoTableData([]);
    setRedoTableData([]);
    redirectState.set(false);
    dragItem.current = null;
    shouldShowPublishNow.set(true);

    if (!descError) {

      dispatch(COMMON_SERVICES.saveWorksheetServices(payload)).then(() => {
        mapSideNavTabState.set("Campaigns");
        dispatch(COMMON_SERVICES.getWelcomeAdsImageServices(siteId.get()));
      });
    }
  }

  const dragStart = (val) => {
    dragItem.current = val;
  }

  const dragOver = (e) => {
    e.preventDefault();
  }
  // ************************************************************ Drag Drop ****************************************************************************************

  const dragDrop = (e, type, index, courseIndex, courseDetail) => {
    if (dragItem?.current?.id == undefined) {
      return;
    }

    undoTableData.push(tableData);

    if (dragItem?.current?.id) {
      const changeStatusButton = [...activeButton];
      changeStatusButton[courseIndex] = true;
    }

    const id = e.currentTarget?.id;

    let tableDataTemp = JSON.parse(JSON.stringify(tableData));
    let allCampDataTemp = JSON.parse(JSON.stringify(allCampData));

    if (type === "textField3") {
      allCampDataTemp[id].imageId = dragItem.current.id;
      allCampDataTemp[id].modified = true;
      setAllCampData(allCampDataTemp);
    } else if (type === "welcomeImageField") {
      const welcomeImagesTemp = [...welcomeImages];
      const imageIndex = parseInt(id.replace('welcomeImage', '')) - 1;
      welcomeImagesTemp[imageIndex].WelcomeAdId = dragItem.current.id;

      // If dropping on the last row, automatically add a new empty row
      if (imageIndex === welcomeImagesTemp.length - 1) {
        welcomeImagesTemp.push({
          WelcomeAdId: 0
        });
        setWelcomeImageSlots(welcomeImagesTemp.length);
        setTempSlotCount(welcomeImagesTemp.length);
      }

      setWelcomeImages(welcomeImagesTemp);
    } else if (type === "tableFieldData") {
      if (dragItem.current.fullPage && id.includes("teeFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && id.includes("teeInsertImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && id.includes("fairwayFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (
        !dragItem.current.fullPage &&
        id.includes("fairwayInsertImage")
      ) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && id.includes("greenFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (
        !dragItem.current.fullPage &&
        id.includes("greenInsertImage")
      ) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && id.includes("g2tFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && id.includes("rotationAd")) {
        tableDataTemp[courseIndex][id].imageId = dragItem.current.id;
        tableDataTemp[courseIndex][id].modified = true;
        setTableData(tableDataTemp);
      }
    } else if (type.includes("tableFieldHeader")) {
      if (dragItem.current.fullPage && type.includes("TeeTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["teeFullImage"].imageId = dragItem.current.id;
          value["teeFullImage"].modified = true;

          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("TeeTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["teeInsertImage"].imageId = dragItem.current.id;
          value["teeInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("FairwayTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["fairwayFullImage"].imageId = dragItem.current.id;
          value["fairwayFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("FairwayTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["fairwayInsertImage"].imageId = dragItem.current.id;
          value["fairwayInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("GreenTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["greenFullImage"].imageId = dragItem.current.id;
          value["greenFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("GreenTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["greenInsertImage"].imageId = dragItem.current.id;
          value["greenInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("Green2Table")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["g2tFullImage"].imageId = dragItem.current.id;
          value["g2tFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("AllTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["g2tFullImage"].imageId = dragItem.current.id;
          value["g2tFullImage"].modified = true;
          value["greenFullImage"].imageId = dragItem.current.id;
          value["greenFullImage"].modified = true;
          value["fairwayFullImage"].imageId = dragItem.current.id;
          value["fairwayFullImage"].modified = true;
          value["teeFullImage"].imageId = dragItem.current.id;
          value["teeFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("AllTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["greenInsertImage"].imageId = dragItem.current.id;
          value["greenInsertImage"].modified = true;
          value["fairwayInsertImage"].imageId = dragItem.current.id;
          value["fairwayInsertImage"].modified = true;
          value["teeInsertImage"].imageId = dragItem.current.id;
          value["teeInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      }
    } else if (type === "AllRowTable") {
      if (dragItem.current.fullPage) {
        tableDataTemp[courseIndex].holes[index]["teeFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index]["teeFullImage"].modified = true;
        tableDataTemp[courseIndex].holes[index]["fairwayFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "fairwayFullImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["greenFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "greenFullImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["g2tFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index]["g2tFullImage"].modified = true;

        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage) {
        tableDataTemp[courseIndex].holes[index]["teeInsertImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "teeInsertImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["fairwayInsertImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "fairwayInsertImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["greenInsertImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "greenInsertImage"
        ].modified = true;
        setTableData(tableDataTemp);
      }
    }

    setPrevTableData(tableData);
    if (tableDataTemp && courseDetail) {
      setCoursesPayload(prevPayload => {
        const updatedPayload = [...prevPayload];
        const existingCourseIndex = prevPayload.findIndex(course => course.id === courseDetail?.id);

        if (existingCourseIndex !== -1) {
          updatedPayload[existingCourseIndex] = tablePayload(tableDataTemp, courseDetail, courseIndex);
        } else {
          updatedPayload.push(tablePayload(tableDataTemp, courseDetail, courseIndex));
        }

        return updatedPayload;
      });
    }
  }

  // ************************************************************ Delete All ****************************************************************************************
  const deleteAllDesc = (e, type, index, courseIndex, courseDetail) => {
    e.stopPropagation();

    undoTableData.push(tableData);
    setTimeout(() => {
      const changeStatusButton = [...activeButton];
      changeStatusButton[courseIndex] = true;

      const { id } = e.target;
      let tableDataTemp = JSON.parse(JSON.stringify(tableData));

      if (type === "welcomeImageField") {
        const welcomeImagesTemp = [...welcomeImages];
        const imageIndex = parseInt(id.replace('welcomeImage', '')) - 1;
        welcomeImagesTemp[imageIndex].WelcomeAdId = 0;
        setWelcomeImages(welcomeImagesTemp);
      } else if (type === "tableFieldData") {
        if (id.includes("teeFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("teeInsertImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("fairwayFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("fairwayInsertImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("greenFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("greenInsertImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("g2tFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("rotationAd")) {
          tableDataTemp[courseIndex][id].imageId = 0;
          tableDataTemp[courseIndex][id].modified = true;
          setTableData(tableDataTemp);
        }
      } else if (type.includes("tableFieldHeader")) {
        if (type.includes("TeeTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["teeFullImage"].imageId = 0;
            value["teeFullImage"].modified = true;
            value["teeInsertImage"].imageId = 0;
            value["teeInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("FairwayTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["fairwayFullImage"].imageId = 0;
            value["fairwayFullImage"].modified = true;
            value["fairwayInsertImage"].imageId = 0;
            value["fairwayInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("GreenTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["greenFullImage"].imageId = 0;
            value["greenFullImage"].modified = true;
            value["greenInsertImage"].imageId = 0;
            value["greenInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("Green2Table")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["g2tFullImage"].imageId = 0;
            value["g2tFullImage"].modified = true;

            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("RemoveAllTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["g2tFullImage"].imageId = 0;
            value["g2tFullImage"].modified = true;
            value["greenFullImage"].imageId = 0;
            value["greenFullImage"].modified = true;
            value["fairwayFullImage"].imageId = 0;
            value["fairwayFullImage"].modified = true;
            value["teeFullImage"].imageId = 0;
            value["teeFullImage"].modified = true;
            value["greenInsertImage"].imageId = 0;
            value["greenInsertImage"].modified = true;
            value["fairwayInsertImage"].imageId = 0;
            value["fairwayInsertImage"].modified = true;
            value["teeInsertImage"].imageId = 0;
            value["teeInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        }
      }

      setPrevTableData(tableData);
      if (tableDataTemp && courseDetail) {
        setCoursesPayload(prevPayload => {
          const updatedPayload = [...prevPayload];
          const existingCourseIndex = prevPayload.findIndex(course => course.id === courseDetail?.id);

          if (existingCourseIndex !== -1) {
            // Course exists, update it
            updatedPayload[existingCourseIndex] = tablePayload(tableDataTemp, courseDetail, courseIndex);
          } else {
            // Course doesn't exist, don't add it again, just update the table data
            updatedPayload.push(tablePayload(tableDataTemp, courseDetail, courseIndex));
          }

          return updatedPayload;
        });
      }
    }, 5);
  }

  const handleChangeArchive = (event) => {
    setArchiveId(event.target.value);
    setDetectArchiveChange(true);
  }

  const handleOpenOnLoad = (rowID) => {
    setOpenLoadCampaignArchiveConfirmation(true);
    setArchiveCampId(rowID);
  }

  const handleOpenLoadCampaignArchiveConfirmation = () => {
    setDetectArchiveChange(false);
    dispatch(COMMON_SERVICES.getArchiveServices(archiveId, archiveCampId)).then(
      () => {
        setOpenLoadCampaignArchiveConfirmation(false);
        handleArchivedCampaignModalClose();
        mapSideNavTabState.set("Campaigns");
      }
    );
  }

  const handleStartDate = (date) => {
    if (date) {
      date.setHours(4);
      date.setMinutes(0);
      date.setSeconds(0);
      setStartDate(date);
    }
  }

  const handleEndDate = (date) => {
    if (date) {
      date.setHours(4);
      date.setMinutes(0);
      date.setSeconds(0);
      setEndDate(date);
    }
  }

  const handleSlotCountChange = (newCount) => {
    if (newCount < 1 || newCount > 50) return; // Set reasonable limits

    const currentImages = [...welcomeImages];
    let newImages = [];

    // If increasing slots, add new empty slots
    if (newCount > currentImages.length) {
      newImages = [...currentImages];
      for (let i = currentImages.length; i < newCount; i++) {
        newImages.push({
          WelcomeAdId: 0
        });
      }
    } else {
      // If decreasing slots, keep only the first N slots
      newImages = currentImages.slice(0, newCount);
    }

    setWelcomeImageSlots(newCount);
    setWelcomeImages(newImages);
  }

  const handleSlotInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      const newCount = parseInt(tempSlotCount);
      if (!isNaN(newCount) && newCount > 0 && newCount <= 50) {
        handleSlotCountChange(newCount);
      } else {
        // Reset to current count if invalid
        setTempSlotCount(welcomeImageSlots);
      }
    }
  }

  function verboseDateToString(vd, format) {
    let m = moment(
      new Date(
        Date.UTC(vd.year, vd.month - 1, vd.day, vd.hour, vd.minute, vd.second)
      )
    );
    if (format) {
      return m.format(format);
    } else {
      return m.format("ddd DD/MMM/YY HH:mm:ss");
    }
  }

  function getCampaignImageValidation({
    singleCampaignData,
    welcomeImages,
    allCampData,
  }) {
    const isDefaultCampaign =
      singleCampaignData?.Description === "Default campaign";

    const hasValidWelcomeImages =
      Array.isArray(welcomeImages) &&
      welcomeImages.some(
        (img) => Number(img?.WelcomeAdId) > 0
      );

    const isWelcomeMissing = !hasValidWelcomeImages;

    const isFbMissing = !Number(allCampData?.fbAd?.imageId);

    return {
      isDefaultCampaign,
      isWelcomeMissing,
      isFbMissing,
    };
  }
  const {
    isWelcomeMissing,
    isFbMissing,
  } = getCampaignImageValidation({
    singleCampaignData,
    welcomeImages,
    allCampData,
  });
  return (
    <Container>
      <Header className="edit-campaign-header">
        <Tooltip
          title={t("Load_previously_published_ad_set_to_worksheet")}
          className="title"
        >
          <CircleBtn onClick={() => setOpenArchivedCampaignModal(true)}>
            <DeleteIcon
              color="#fff"
              width={10}
              height={12}
              disabled={getFeatureSetOption(siteSettingsData.Features, getFeaturesList().adman_event) && getUserRole && getUserRole.Role !== 6}
            />
            {t("Load_from_archive")}
          </CircleBtn>
        </Tooltip>
        <div>
          <Modal
            open={openArchivedCampaignModal}
            onClose={handleArchivedCampaignModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={campaignContainerModalStyle}>
              <ArchivedCampaignContainerModal>
                <div className="header">
                  <h3>{t("Load_ads_from_archived_campaign")}</h3>
                  <button>
                    <CloseIcon onClick={handleArchivedCampaignModalClose} />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="input-wrapper">
                    <p className="label">{t("Select_archived_campaign")}:</p>
                    <FormControl fullWidth>
                      <InputLabel id="select-label">
                        Choose Version..
                      </InputLabel>
                      <Select
                        disabled={getFeatureSetOption(siteSettingsData.Features, getFeaturesList().adman_event)}
                        value={archiveId}
                        label="Choose Version.."
                        onChange={handleChangeArchive}
                      >
                        {modifiedArchive?.map((ad, index) => (
                          <MenuItem key={index} value={ad.version}>
                            {"Ver " +
                              ad.version +
                              " | " +
                              ad.comment +
                              " [" +
                              verboseDateToString(
                                ad.publishedUtc,
                                "DD-MMM-YY"
                              ) +
                              " " +
                              ad.publishedBy +
                              "]"}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="action-btn">
                    <button
                      disabled={
                        !detectArchiveChange ||
                        getFeatureSetOption(
                          siteSettingsData.Features,
                          getFeaturesList().adman_event
                        )
                      }
                      onClick={() => handleOpenOnLoad(singleCampaignData.Id)}
                    >
                      {t("Load")}
                    </button>
                    <button
                      onClick={() => {
                        handleArchivedCampaignModalClose();
                        setDetectArchiveChange(false);
                        setArchiveId("");
                      }}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              </ArchivedCampaignContainerModal>
            </Box>
          </Modal>
        </div>

        <Modal
          open={openLoadCampaignArchiveConfirmation}
          onClose={() => setOpenLoadCampaignArchiveConfirmation(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <PopUpContainer>
              <h2>{t("Confirm_load")}</h2>
              <p>{t("Load_campaign_from_archive")}?</p>
              <div className="action-btn">
                <button
                  className="primary"
                  onClick={() => handleOpenLoadCampaignArchiveConfirmation()}
                  variant="contained"
                >
                  {t("Yes")}
                </button>
                <button onClick={() => setOpenLoadCampaignArchiveConfirmation(false)}>
                  {t("No")}
                </button>
              </div>
            </PopUpContainer>
          </Box>
        </Modal>

        <div className="input-wrapper">
          <p>{t("Last_modified")} :</p>
          <p className="date">
            {modifiedDate()} by {worksheet().by}
          </p>
        </div>
        <Tooltip title={t("Close")}>
          <CircleBtn
            className="circle-btn"
            onClick={(e) => {
              alertMsg.set(true)
            }}
          >
            <CloseIcon height={18} width={20}></CloseIcon> {t("Close")}{" "}
          </CircleBtn>
        </Tooltip>
      </Header>

      <Wrapper>
        <CenterSection>
          <div>
            <DescriptionSection className="description-section">
              <div className="main-wrapper">
                <div className="input-wrapper">
                  <p>{t("Description")}:</p>
                  <input
                    type="text"
                    value={descInputValue}
                    onChange={(e) => {
                      setDescInputValue(e.target.value);

                      if (e.target.value.trim().length > 0) {
                        setDescError(false);
                      } else {
                        setDescError(true);
                      }
                    }}
                  />
                  {descError ? (
                    <p className="error-msg"> Please Enter The Description </p>
                  ) : null}
                </div>

                {singleCampaignData?.Description === "Default campaign" ||
                  singleCampaignData?.startDateUtc === null ? (
                  <></>
                ) : (
                  <div className="input-wrapper">
                    <p className="label">{t("First_day")}</p>
                    <DatePicker
                      open={startOpen}
                      onClickOutside={() => setStartOpen(false)}
                      onInputClick={() => setStartOpen(true)}
                      openToDate={startDate || new Date()}
                      dateFormat="dd-MMM-yyyy"
                      selected={startDate}
                      onChange={(date) => {
                        handleStartDate(date);
                        setStartOpen(false)
                      }}
                      renderCustomHeader={({
                        monthDate,
                        decreaseMonth,
                        increaseMonth,
                      }) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "4px 8px",
                          }}
                        >
                          <button onClick={decreaseMonth}>{"<"}</button>
                          <span>{moment(monthDate).format("MMMM YYYY")}</span>
                          <button onClick={increaseMonth}>{">"}</button>
                        </div>
                      )}
                      calendarContainer={({ className, children }) => (
                        <div className={className}>
                          {children}
                          <div
                            style={{
                              textAlign: "center",
                              padding: "6px 0",
                              borderTop: "1px solid #e0e0e0",
                            }}
                          >
                            <button
                              onClick={() => {
                                handleStartDate(moment().startOf("day").toDate())
                                setStartOpen(false);
                              }}
                              style={{
                                background: "transparent",
                                border: "none",
                                borderBottom: "2px solid #1976d2",
                                color: "#1976d2",
                                cursor: "pointer",
                                fontSize: "13px",
                              }}
                            >
                              {moment().format("dddd, MMMM D, YYYY")}
                            </button>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                )}

                {singleCampaignData?.Description === "Default campaign" ||
                  singleCampaignData?.endDateUtc === null ? (
                  <></>
                ) : (
                  <div className="input-wrapper">
                    <>
                      <p className="label">{t("Last_day")}</p>
                      <DatePicker
                        open={endOpen}
                        onClickOutside={() => setEndOpen(false)}
                        onInputClick={() => setEndOpen(true)}
                        openToDate={endDate || new Date()}
                        dateFormat="dd-MMM-yyyy"
                        selected={endDate}
                        onChange={(date) => {
                          handleEndDate(date);
                          setEndOpen(false)
                        }}
                        minDate={startDate}
                        renderCustomHeader={({ monthDate, decreaseMonth, increaseMonth }) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "4px 8px",
                            }}
                          >
                            <button onClick={decreaseMonth}>{"<"}</button>

                            <span>{moment(monthDate).format("MMMM YYYY")}</span>

                            <button onClick={increaseMonth}>{">"}</button>
                          </div>
                        )}

                        calendarContainer={({ className, children }) => (
                          <div className={className}>
                            {children}

                            <div
                              style={{
                                textAlign: "center",
                                padding: "6px 0",
                                borderTop: "1px solid #e0e0e0",
                              }}
                            >
                              <button
                                onClick={() => {
                                  handleEndDate(moment().startOf("day").toDate())
                                  setEndOpen(false)
                                }}
                                style={{
                                  background: "transparent",
                                  border: "none",
                                  borderBottom: "2px solid #1976d2",
                                  color: "#1976d2",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                {moment().format("dddd, MMMM D, YYYY")}
                              </button>
                            </div>
                          </div>
                        )}
                      />
                    </>
                  </div>
                )}

                <div className="input-wrapper">
                  <p className="label">
                    {t("F&B_Ad")}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flex: 1,
                    }}
                  >
                    <Tooltip title={imageName(allCampData?.fbAd?.imageId)}>
                      <span
                        id="fbAd"
                        onDragOver={(e) => dragOver(e)}
                        onDrop={(e) => dragDrop(e, "textField3")}
                        onClick={(e) => dragDrop(e, "textField3")}
                        className="editable"
                        style={{
                          flex: 1,
                        }}
                      >
                        {imageName(allCampData?.fbAd?.imageId) || ""}
                      </span>
                    </Tooltip>
                    {isFbMissing && (
                      <span style={{ color: "red", marginLeft: "8px", fontSize: "14px" }}>
                        Missing F&B image
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <NormalBtn className="circle-btn">
                <Button
                  variant="outlined"
                  onClick={() => {
                    alertMsg.set(true);
                  }}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  variant="outlined"
                  style={{ margin: 5 }}
                  className={"active"}
                  onClick={handleSaveEditDesc}
                >
                  {t("Save")}
                </Button>
              </NormalBtn>

            </DescriptionSection>
            <Section className="campaigns-main-section">
              <MainDataWrapper>
                {/* Welcome Images Accordion */}
                <AccordionContainer>
                  <Accordion expanded={welcomeImagesExpanded}>
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          onClick={() => setWelcomeImagesExpanded(!welcomeImagesExpanded)}
                        />
                      }
                      aria-controls="welcome-images-content"
                      id="welcome-images-header"
                    >
                      <div className="header">
                        <div className="left-wrapper">
                          <h4>{t("Welcome_Images")}</h4>
                          {isWelcomeMissing && (
                            <span style={{ color: "red", marginLeft: "8px", fontSize: "14px" }}>
                              Missing welcome images
                            </span>
                          )}
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <TableWrapper>
                        <table>
                          <tr>
                            <th>{t("S_No")}</th>
                            <th>{t("Image")}</th>
                          </tr>
                          {(() => {
                            return welcomeImages.map((welcomeImg, index) => {
                              return (
                                <tr key={index}>
                                  <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                    {index + 1}
                                  </td>
                                  <td
                                    id={`welcomeImage${index + 1}`}
                                    style={{
                                      cursor: "pointer",
                                      minHeight: "40px",
                                      border: "1px dashed #ccc",
                                      padding: "10px",
                                      textAlign: "center",
                                      position: "relative"
                                    }}
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) => dragDrop(e, "welcomeImageField")}
                                    onClick={(e) => dragDrop(e, "welcomeImageField")}
                                  >
                                    {imageName(welcomeImg.WelcomeAdId) !== "" ? (
                                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <span style={{ flex: 1 }}>{imageName(welcomeImg.WelcomeAdId)}</span>
                                        <button
                                          id={`welcomeImage${index + 1}`}
                                          style={{
                                            marginLeft: "10px",
                                            border: "none",
                                            background: "none",
                                            cursor: "pointer",
                                            padding: "2px"
                                          }}
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "welcomeImageField"
                                            )
                                          }
                                        >
                                          <CrossIcon
                                            width={12}
                                            height={12}
                                            pointerEvents="none"
                                          />
                                        </button>
                                      </div>
                                    ) : (
                                      <span style={{ color: "#999", fontStyle: "italic" }}>
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            });
                          })()}
                        </table>
                      </TableWrapper>
                    </AccordionDetails>
                  </Accordion>
                </AccordionContainer>

                {tableData &&
                  tableData?.length !== 0 &&
                  tableData?.map((course, index) => {
                    let panelString = `panel ${index + 1}`;
                    return (
                      <AccordionContainer>
                        <Accordion expanded={expanded === panelString}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                onClick={handleChange(panelString)}
                              />
                            }
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <div className="header">
                              <div className="left-wrapper">
                                <h4>{course?.name}</h4>
                                <div className="input-wrapper">
                                  <p>{t("Default_insert_ad")}</p>

                                  <span
                                    id="rotationAd"
                                    style={{
                                      padding: "0",
                                      fontSize: "12px",
                                      width: "80px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "inline-flex",
                                      height: "24px",
                                      border: "1px solid #636f7c",
                                      borderRadius: "3px",
                                      padding: "2px",
                                    }}
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldData",
                                        index,
                                        index,
                                        course
                                      )
                                    }
                                    onClick={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldData",
                                        index,
                                        index,
                                        course
                                      )
                                    }
                                  >
                                    {imageName(course?.rotationAd?.imageId) !==
                                      "" ? (
                                      <>
                                        <p
                                          id="rotationAd"
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {imageName(
                                            course?.rotationAd?.imageId
                                          )}
                                        </p>
                                        <button
                                          id="rotationAd"
                                          style={{ border: "none" }}
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldData",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CrossIcon
                                            width={12}
                                            height={12}
                                            pointerEvents="none"
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="button-wrapper">
                                <Tooltip title={t("Redo")} className="title">
                                  <button
                                    onClick={(e) =>
                                      redoFunc(
                                        tableData,
                                        setTableData,
                                        redoTableData,
                                        undoTableData
                                      )
                                    }
                                  >
                                    <RedoIcon />
                                  </button>
                                </Tooltip>
                                <Tooltip title={t("Undo")} className="title">
                                  <button
                                    onClick={(e) =>
                                      undoFunc(
                                        tableData,
                                        setTableData,
                                        undoTableData,
                                        redoTableData
                                      )
                                    }
                                  >
                                    <UndoIcon />
                                  </button>
                                </Tooltip>
                              </div>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <TableWrapper>
                              <table>
                                <tr>
                                  <th
                                    id="all"
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldHeaderAllTable",
                                        index,
                                        index,
                                        course
                                      )
                                    }
                                  >
                                    <span>{t("All")}</span>
                                    <div className="icon-wrapper">
                                      <Tooltip title={t("Copy_All")}>
                                        <button
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldHeaderAllTable",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CopyIcon width={20} height={20} />
                                        </button>
                                      </Tooltip>
                                      <Tooltip title={t("Delete_All")}>
                                        <button
                                          id="removeAll"
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldHeaderRemoveAllTable",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CrossIcon pointerEvents="none" />
                                        </button>
                                      </Tooltip>
                                    </div>
                                  </th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) || (getUserRole && getUserRole.Role === userRoles.admin)) && (
                                      <th
                                        colSpan="2"
                                        id="tee"
                                        onDragOver={(e) => dragOver(e)}
                                        onDrop={(e) =>
                                          dragDrop(
                                            e,
                                            "tableFieldHeaderTeeTable",
                                            index,
                                            index,
                                            course
                                          )
                                        }
                                      >
                                        <span>Tee</span>
                                        <div className="icon-wrapper gap">
                                          <Tooltip title={t("Copy")}>
                                            <button
                                              onClick={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldHeaderTeeTable",
                                                  index,
                                                  index,
                                                  course
                                                )
                                              }
                                            >


                                              <CopyIcon width={20} height={20} />

                                            </button>
                                          </Tooltip>
                                          <Tooltip title={t("Delete")}>
                                            <button
                                              id="removeTee"
                                              onClick={(e) =>
                                                deleteAllDesc(
                                                  e,
                                                  "tableFieldHeaderTeeTable",
                                                  index,
                                                  index,
                                                  course
                                                )
                                              }
                                            >
                                              <CrossIcon pointerEvents="none" />
                                            </button>
                                          </Tooltip>
                                        </div>
                                      </th>
                                    )}


























                                  <th
                                    colSpan="2"
                                    id="fairway"
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldHeaderFairwayTable",
                                        index,
                                        index,
                                        course
                                      )
                                    }
                                  >
                                    <span>{t("Fairway")}</span>
                                    <div className="icon-wrapper gap">
                                      <Tooltip title={t("Copy")}>
                                        <button
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldHeaderFairwayTable",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CopyIcon width={20} height={20} />
                                        </button>
                                      </Tooltip>
                                      <Tooltip title={t("Delete")}>
                                        <button
                                          id="removeFairway"
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldHeaderFairwayTable",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CrossIcon />
                                        </button>
                                      </Tooltip>
                                    </div>
                                  </th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role === userRoles.admin)) && (
                                      <th
                                        colSpan="2"
                                        id="green"
                                        onDragOver={(e) => dragOver(e)}
                                        onDrop={(e) =>
                                          dragDrop(
                                            e,
                                            "tableFieldHeaderGreenTable",
                                            index,
                                            index,
                                            course
                                          )
                                        }
                                      >
                                        <span>{t("Green")}</span>
                                        <div className="icon-wrapper gap">
                                          <Tooltip title={t("Copy")}>
                                            <button
                                              onClick={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldHeaderGreenTable",
                                                  index,
                                                  index,
                                                  course
                                                )
                                              }
                                            >


                                              <CopyIcon width={20} height={20} />

                                            </button>
                                          </Tooltip>
                                          <Tooltip title={t("Delete")}>
                                            <button
                                              id="removeGreen"
                                              onClick={(e) =>
                                                deleteAllDesc(
                                                  e,
                                                  "tableFieldHeaderGreenTable",
                                                  index,
                                                  index,
                                                  course
                                                )
                                              }
                                            >
                                              <CrossIcon />
                                            </button>
                                          </Tooltip>
                                        </div>
                                      </th>
                                    )}

                                  <th
                                    id="green2t"
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldHeaderGreen2Table",
                                        index,
                                        index,
                                        course
                                      )
                                    }
                                  >
                                    <span>{t("Green-to-Tee")}</span>{" "}
                                    <div className="icon-wrapper gap">
                                      <Tooltip title={t("Copy")}>
                                        <button
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldHeaderGreen2Table",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CopyIcon width={20} height={20} />
                                        </button>
                                      </Tooltip>
                                      <Tooltip title={t("Delete")}>
                                        <button
                                          id="removeG2T"
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldHeaderGreen2Table",
                                              index,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          <CrossIcon />
                                        </button>
                                      </Tooltip>
                                    </div>
                                  </th>
                                </tr>
                                <tr className="sec-header">
                                  <th>{t("Hole")}</th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role === userRoles.admin)) && (

                                      <th colSpan="2">
                                        <div className="page-type">
                                          <span>{t("Full_page")}</span>
                                          <span>{t("Insert")}</span>
                                        </div>
                                      </th>
                                    )}









                                  <th colSpan="2">
                                    <div className="page-type">
                                      <span>{t("Full_page")}</span>
                                      <span>{t("Insert")}</span>
                                    </div>
                                  </th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role == userRoles.admin)) && (

                                      <th colSpan="2">
                                        <div className="page-type">
                                          <span>{t("Full_page")}</span>
                                          <span>{t("Insert")}</span>
                                        </div>
                                      </th>
                                    )}









                                  <th>{t("Full_page")}</th>
                                </tr>
                                {course?.holes &&
                                  course?.holes?.map((hole, holeIndex) => {
                                    return (
                                      <tr>
                                        <td
                                          id="AllRow"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "AllRowTable",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "AllRowTable",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          {hole?.number}
                                        </td>
                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role == userRoles.admin)) && (
                                            <td
                                              id="teeFullImage"
                                              style={{ cursor: "pointer" }}
                                              onDragOver={(e) => dragOver(e)}
                                              onDrop={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                              onClick={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                            >
                                              {imageName(
                                                hole?.teeFullImage?.imageId
                                              ) !== "" ? (
                                                <>
                                                  {imageName(
                                                    hole?.teeFullImage?.imageId
                                                  )}
                                                  <button
                                                    id="teeFullImage"
                                                    onClick={(e) =>
                                                      deleteAllDesc(
                                                        e,
                                                        "tableFieldData",
                                                        holeIndex,
                                                        index,
                                                        course
                                                      )
                                                    }
                                                  >
                                                    <CrossIcon
                                                      width={12}
                                                      height={12}
                                                      pointerEvents="none"
                                                    />
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                          )}

                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role === userRoles.admin)) && (
                                            <td
                                              id="teeInsertImage"
                                              style={{ cursor: "pointer" }}
                                              onDragOver={(e) => dragOver(e)}
                                              onDrop={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                              onClick={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                            >
                                              {imageName(
                                                hole?.teeInsertImage?.imageId
                                              ) !== "" ? (
                                                <>
                                                  {imageName(
                                                    hole?.teeInsertImage?.imageId

                                                  )}
                                                  <button
                                                    id="teeInsertImage"
                                                    onClick={(e) =>
                                                      deleteAllDesc(
                                                        e,
                                                        "tableFieldData",
                                                        holeIndex,
                                                        index,
                                                        course
                                                      )
                                                    }
                                                  >
                                                    <CrossIcon
                                                      width={12}
                                                      height={12}
                                                      pointerEvents="none"
                                                    />
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                          )}

                                        <td
                                          id="fairwayFullImage"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          {imageName(
                                            hole?.fairwayFullImage?.imageId
                                          ) !== "" ? (
                                            <>
                                              {imageName(
                                                hole?.fairwayFullImage?.imageId
                                              )}
                                              <button
                                                id="fairwayFullImage"
                                                onClick={(e) =>
                                                  deleteAllDesc(
                                                    e,
                                                    "tableFieldData",
                                                    holeIndex,
                                                    index,
                                                    course
                                                  )
                                                }
                                              >
                                                <CrossIcon
                                                  width={12}
                                                  height={12}
                                                  pointerEvents="none"
                                                />
                                              </button>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                        <td
                                          id="fairwayInsertImage"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          {imageName(
                                            hole?.fairwayInsertImage?.imageId
                                          ) !== "" ? (
                                            <>
                                              {imageName(
                                                hole?.fairwayInsertImage
                                                  ?.imageId
                                              )}
                                              <button
                                                id="fairwayInsertImage"
                                                onClick={(e) =>
                                                  deleteAllDesc(
                                                    e,
                                                    "tableFieldData",
                                                    holeIndex,
                                                    index,
                                                    course
                                                  )
                                                }
                                              >
                                                <CrossIcon
                                                  width={12}
                                                  height={12}
                                                  pointerEvents="none"
                                                />
                                              </button>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role === userRoles.admin)) && (
                                            <td
                                              id="greenFullImage"
                                              style={{ cursor: "pointer" }}
                                              onDragOver={(e) => dragOver(e)}
                                              onDrop={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                              onClick={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                            >
                                              {imageName(
                                                hole?.greenFullImage?.imageId
                                              ) !== "" ? (
                                                <>
                                                  {imageName(
                                                    hole?.greenFullImage?.imageId

                                                  )}
                                                  <button
                                                    id="greenFullImage"
                                                    onClick={(e) =>
                                                      deleteAllDesc(
                                                        e,
                                                        "tableFieldData",
                                                        holeIndex,
                                                        index,
                                                        course
                                                      )
                                                    }
                                                  >
                                                    <CrossIcon
                                                      width={12}
                                                      height={12}
                                                      pointerEvents="none"
                                                    />
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                          )}

                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role === userRoles.admin)) && (
                                            <td
                                              id="greenInsertImage"
                                              style={{ cursor: "pointer" }}
                                              onDragOver={(e) => dragOver(e)}
                                              onDrop={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                              onClick={(e) =>
                                                dragDrop(
                                                  e,
                                                  "tableFieldData",
                                                  holeIndex,
                                                  index,
                                                  course
                                                )
                                              }
                                            >
                                              {imageName(
                                                hole?.greenInsertImage?.imageId
                                              ) !== "" ? (
                                                <>
                                                  {imageName(
                                                    hole?.greenInsertImage
                                                      ?.imageId
                                                  )}
                                                  <button
                                                    id="greenInsertImage"
                                                    onClick={(e) =>
                                                      deleteAllDesc(
                                                        e,
                                                        "tableFieldData",
                                                        holeIndex,
                                                        index,
                                                        course
                                                      )
                                                    }
                                                  >
                                                    <CrossIcon
                                                      width={12}
                                                      height={12}
                                                      pointerEvents="none"
                                                    />
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                          )}

                                        <td
                                          id="g2tFullImage"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course
                                            )
                                          }
                                        >
                                          {imageName(
                                            hole?.g2tFullImage?.imageId
                                          ) !== "" ? (
                                            <>
                                              {imageName(
                                                hole?.g2tFullImage?.imageId
                                              )}
                                              <button
                                                id="g2tFullImage"
                                                onClick={(e) =>
                                                  deleteAllDesc(
                                                    e,
                                                    "tableFieldData",
                                                    holeIndex,
                                                    index,
                                                    course
                                                  )
                                                }
                                              >
                                                <CrossIcon
                                                  width={12}
                                                  height={12}
                                                  pointerEvents="none"
                                                />
                                              </button>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </table>
                            </TableWrapper>
                          </AccordionDetails>
                        </Accordion>
                      </AccordionContainer>
                    );
                  })}
              </MainDataWrapper>
            </Section>
          </div>
          <GallerySection>
            <PreviewBox>
              <AdPreview>
                <ImagePreviewBox>
                  {showImage && (
                    <img
                      src={showImage.base64data}
                      className="full-view-image"
                      alt="AdPreviewImage"
                      onDragStart={() => dragStart(showImage)}
                      onClick={() => dragStart(showImage)}
                    />
                  )}
                </ImagePreviewBox>
              </AdPreview>
            </PreviewBox>
            <GalleryHeading>
              <h3>{t("Gallery")}</h3>
              <SearchWrapper>
                <Tooltip title={t("Type_partial_filename_to_filter_the_list")}>
                  <input
                    type="text"
                    placeholder={t("Search")}
                    onChange={(e) =>
                      gallerySearch(
                        e,
                        searchFullImagesArray,
                        setFullImagesArray,
                        searchInsertClonedArray,
                        setInsertClonedArray
                      )
                    }
                  />
                </Tooltip>
                <img src={SearchIcon} alt="search-icon" />
              </SearchWrapper>
            </GalleryHeading>
            <Status>
              <div className="row-div">
                <p className="label">{t("Status")}</p>
                <div className="btn-wrapper">
                  <Tooltip title={t("Shared")} className="title">
                    <button
                      className={sharedImages ? "active" : ""}
                      onClick={() => {
                        setSharedImages(!sharedImages);
                      }}
                    >
                      {t("Shared")}
                    </button>
                  </Tooltip>
                  <Tooltip title={t("Local")} className="title">
                    <button
                      className={localImages ? "active" : ""}
                      onClick={() => {
                        setLocalImages(!localImages);
                      }}
                    >
                      {t("Local")}
                    </button>
                  </Tooltip>
                </div>
                <p className="label">{t("Sort_by")}</p>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <Select
                      defaultValue="date"
                      onChange={(e) => setDropDownValue(e.target.value)}
                    >
                      <MenuItem value="date">{t("Date_uploaded")}</MenuItem>
                      <MenuItem value="desc">{t("Description")}</MenuItem>
                      <MenuItem value="file">{t("File_name")}</MenuItem>
                      <MenuItem value="size">{t("Image_size")}</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </Status>
            <GalleryDetails>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="full"
                name="radio-buttons-group"
                onChange={(e) => {
                  setRadioInputValue(e.target.value);
                  setShowImage("");
                }}
              >
                <Tooltip title={t("Full_page")} className="title">
                  <FormControlLabel
                    value="full"
                    control={
                      <Radio
                        checkedIcon={<CheckedIcon />}
                        icon={<UnCheckedIcon />}
                      />
                    }
                    label={t("Full_page")}
                  />
                </Tooltip>
                <Tooltip title={t("Insert")} className="title">
                  <FormControlLabel
                    value="insert"
                    control={
                      <Radio
                        checkedIcon={<CheckedIcon />}
                        icon={<UnCheckedIcon />}
                      />
                    }
                    label={t("Insert")}
                  />
                </Tooltip>
              </RadioGroup>
              <GalleryWrapper>
                {radioInputValue === "full" && sharedImages && !localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        ?.filter((item) => {
                          if (item?.fullPage) {
                            return item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${el?.description
                                  } : ${verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD-MMM-YY"
                                  )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, fullImagesArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "full" && !sharedImages && localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        ?.filter((item) => {
                          if (item?.fullPage) {
                            return !item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${el?.description
                                  } : ${verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD-MMM-YY"
                                  )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, fullImagesArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "full" && sharedImages && localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        ?.filter((item) => {
                          return item?.fullPage;
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${el?.description
                                  } : ${verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD-MMM-YY"
                                  )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, fullImagesArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "insert" &&
                  sharedImages &&
                  !localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        ?.filter((item) => {
                          if (!item?.fullPage) {
                            return item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${el?.description
                                  } : ${verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD-MMM-YY"
                                  )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, insertClonedArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "insert" &&
                  !sharedImages &&
                  localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        ?.filter((item) => {
                          if (!item?.fullPage) {
                            return !item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${el?.description
                                  } : ${verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD-MMM-YY"
                                  )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, insertClonedArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "insert" && sharedImages && localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        ?.filter((item) => {
                          return !item?.fullPage;
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${el?.description
                                  } : ${verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD-MMM-YY"
                                  )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, insertClonedArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}
              </GalleryWrapper>
            </GalleryDetails>
          </GallerySection>
        </CenterSection>
      </Wrapper>

      <Modal
        open={alertMsg.get()}
        onClose={() => {
          alertMsg.set(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes_to_campaign")}?</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={() => {
                  alertMsg.set(false);
                  navigateToCampaigns();
                }}
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  alertMsg.set(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditCampaign;